// extracted by mini-css-extract-plugin
export default {"result":"styles_result__Kfm7C"};